export const uppercase = (value) => {
  if (!value) return "";
  return value.toString().toUpperCase();
};

export const currency = (value) => {
  if (isNaN(value)) return "€0.00"; // Validación adicional para evitar errores
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(value);
};

export const percentage = (value) => {
  if (isNaN(value)) return "0%";
  const parsedValue = parseFloat(value);
  return parsedValue % 1 === 0
    ? `${Math.floor(parsedValue)}%`
    : `${parsedValue.toFixed(2)}%`;
};
